if (!customElements.get('canvoil-product-details')) {
  customElements.define('canvoil-product-details', class extends HTMLElement {
    connectedCallback() {
      const info = document.getElementById(`ProductInfo-${this.dataset.section}`);
      if (!info || this.items) return;
      this.items = [...info.querySelectorAll(':scope > .product__accordion')].map(panel => {
        const marker = document.createComment('Product details original position');
        panel.before(marker);
        return {panel, marker};
      });
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.place = () => this.items.forEach(({panel, marker}) => {
        if (this.desktop.matches) this.append(panel);
        else marker.after(panel);
      });
      this.desktop.addEventListener('change', this.place);
      this.place();
    }
    disconnectedCallback() {
      this.desktop?.removeEventListener('change', this.place);
      this.items?.forEach(({panel, marker}) => {
        if (marker.isConnected) marker.replaceWith(panel);
      });
      this.items = null;
    }
  });
}
